import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceService } from './api-service.service';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ReportService {
  constructor(private ApiServiceService: ApiServiceService) {}

  downloadAccountsCsv(date?: string): Observable<Blob> {
    let params = new HttpParams();
    if (date) {
      params = params.set('date', date);
    }
    return this.ApiServiceService.get('/reports/accounts-csv', params, {
      responseType: 'blob',
    });
  }
}
